import OccurrenceMatrix from './OccurrenceMatrix'

export default OccurrenceMatrix
